export default __webpack_public_path__ + "static/media/Armbands of Righteous Smiting.1994ad35.jpg";